import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

const resetPassword = ({ email }: { email: string }) => {
  return api.post("/users/password_reset", {
    email
  });
};

export const useResetPasswordApi = () => {
  const mutation = useMutation({
    mutationKey: ["reset-password"],
    mutationFn: resetPassword
  });

  const serverMessage = mutation.error
    ? (mutation.error as { response?: { data?: { plain?: string } } }).response?.data?.plain
    : undefined;
  const isSsoError = serverMessage?.toLowerCase().includes("managed by an sso provider");
  const errorMessage = isSsoError
    ? "This account uses an SSO provider (e.g. Google or Microsoft) to sign in. Please use the corresponding sign-in button on the login page."
    : serverMessage;

  return {
    resetPassword: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    errorMessage
  };
};
